export const imageBreakpointTypes = ['desktop', 'mobile'] as const
export type ImageBreakpointType = (typeof imageBreakpointTypes)[number]

export type LocalizedAltText = Record<Locale, string>

interface ImageBreakpoints {
  desktop: string
  mobile: string
}

export type ResponsiveImageSource = ImageBreakpoints | string
export type ResponsiveAltTag =
  | Record<ImageBreakpointType, LocalizedAltText>
  | LocalizedAltText

export interface ImageProps {
  src: string
  alt: LocalizedAltText
}

export interface ResponsiveImageProps {
  src: ResponsiveImageSource
  alt: ResponsiveAltTag
}

export interface ContentImage {
  src: ResponsiveImageSource
  alt: LocalizedAltText
}
